import React, { useState, useRef, useEffect } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import {
  LayoutDashboard,
  UserPlus,
  Phone,
  CheckSquare,
  Users, Menu,
  Sidebar
} from "lucide-react";
import ThemeSwitcher from "./ThemeSwitcher";
import SideNavbar from "./SideNavbar";
import TopNav from "./TopNav";
import { useTranslation } from "react-i18next";

const menuItems = [
  { label: "Dashboard", path: "/app", icon: <LayoutDashboard size={20} /> },
  { label: "Create Customer", path: "/app/create-customer", icon: <UserPlus size={20} /> },
  { label: "Telecalling", path: "/app/telecalls", icon: <Phone size={20} /> },
  { label: "Tasks", path: "/app/tasks", icon: <CheckSquare size={20} /> },
  { label: "Users", path: "/app/users", icon: <Users size={20} /> },
];

const Layout = () => {
  const location = useLocation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isRTL, setIsRTL] = useState(localStorage.getItem("rtl") === "true");

  const dropdownRef = useRef();
  const username = "Abdul";
  const email = "abdulhameed16216@gmail.com";
  const { t } = useTranslation();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Update on rtl change in localStorage from ThemeSwitcher
  useEffect(() => {
    const handleStorage = () => {
      setIsRTL(localStorage.getItem("rtl") === "true");
    };
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  return (
    <div className="flex h-screen overflow-hidden" dir={isRTL ? "rtl" : "ltr"}>
      {/* Sidebar */}
      <SideNavbar
        isSidebarOpen={isSidebarOpen}
        isMobileSidebarOpen={isMobileSidebarOpen}
        isRTL={isRTL}
      />

      {/* Main Content */}
      <div
        className={`flex flex-col flex-1 transition-all duration-300 ${isSidebarOpen
          ? isRTL
            ? "sm:mr-64"
            : "sm:ml-64"
          : isRTL
            ? "sm:mr-16"
            : "sm:ml-16"
          } ${isMobileSidebarOpen ? (isRTL ? "mr-16 sm:mr-0" : "ml-16 sm:ml-0") : ""}`}
      >
        <TopNav
          setIsMobileSidebarOpen={setIsMobileSidebarOpen}
          setIsSidebarOpen={setIsSidebarOpen}
        />

        {/* Page Content + Footer */}
        <main className="flex-1 flex flex-col overflow-y-auto bg-gray-100">
          <div className="p-6 flex-1">
            <Outlet />
          </div>
          <footer className="text-center text-sm text-gray-500 py-4 border-t">
            {t('designAndDevelopedBy')}  {" "}
            <a
              href="https://veeyaainnovatives.com"
              className="text-blue-600 hover:underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              veeyaainnovatives.com
            </a>
          </footer>
        </main>
      </div>

      {/* Theme Settings Button */}
      <ThemeSwitcher />
    </div>
  );
};

export default Layout;
